module.exports = __webpack_public_path__ + "img/3g.002deffd.png";